import { useEffect, useState } from "react";
import { getSavedAlbums as getSavedAlbumsFromApi, getSavedAlbumsRequestUrl } from "../../controllers/SpotifyApiController";
import { simplifySavedAlbums } from "../../utils/spotifyUtils";
import { useDispatch, useSelector } from "react-redux";
import { getSavedAlbums as getSavedAlbumsFromState, isSavedAlbumsReset as areSavedAlbumsReset } from "../../reducers/albumListState";
import { setSavedAlbums, updateSavedAlbumsLoadingProgress } from "../../actions/albumListActions";
import { manageTooManyRequestsResponse } from "../../utils/connectionUtils";

export const useSavedAlbums = (pageLimit = 36) => {
    const savedAlbums = useSelector(getSavedAlbumsFromState);
    const reset = useSelector(areSavedAlbumsReset);
    const dispatch = useDispatch();

    const initialPageUrl = getSavedAlbumsRequestUrl(pageLimit);
    const [nextPageUrl, setNextPageUrl] = useState(initialPageUrl);

    useEffect(() => {    
        if(reset && !nextPageUrl)
        {
            setNextPageUrl(initialPageUrl);
        }
        
        if(!reset || !nextPageUrl)
        {
            return;
        }

        getSavedAlbumsFromApi(nextPageUrl)
            .then((result) => {
                if(result.total <= savedAlbums.length)
                {
                    setNextPageUrl(null);
                    return;
                }

                setNextPageUrl(result.next);
                
                dispatch
                (
                    setSavedAlbums
                    (
                        simplifySavedAlbums(result.items)
                    )
                );

                dispatch(updateSavedAlbumsLoadingProgress(result.total));
            })
            .catch((error) => {
                manageTooManyRequestsResponse(error, dispatch);
                console.error('Error fetching saved albums: ', error);
            })
        
    // eslint-disable-next-line
    }, [reset, nextPageUrl, dispatch]);
}